import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../../environments/environment';
import {IInstrument} from '../../worship';

@Injectable()
export class InstrumentService {

    constructor(
        private _http: HttpClient,
    ) {
    }

    list(): Observable<IInstrument[]> {
        return <any>this._http.get(`${environment.api}/worship/instruments`);
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/worship/team/instruments/instrument.service.ts